import React, { useState, useEffect } from "react";
import { DelayLink } from "./DelayLink";
import { Button } from "./Button";
import "./../styles/Navbar.css";
//import { AccountCircleOutlined, HomeOutlined } from "@mui/icons-material";
import {
  AccountCircleOutlined,
  HomeOutlined,
  TaskAltOutlined,
  FactCheckOutlined,
  MonitorHeartOutlined,
  AssessmentOutlined,
} from "@mui/icons-material";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import DashboardIcon from "@mui/icons-material/DashboardTwoTone";
import { Link } from "react-router-dom";
import menus from "../../../src/user-config.json";

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => {
    setClick(false);
  };

  const showButton = () => {
    if (window.innerWidth <= 1080) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  const ResetMenu = () => {
    sessionStorage.clear();
  };

  useEffect(() => {
    console.log("menus", menus.nurse);
    showButton();
  }, []);

  window.addEventListener("resize", showButton);

  if (1 == 1) {
    return (
      <>
        <nav className="topHeader-wrap">
          <div className="logo-wrap">
            <DelayLink to="/" className="exlLogo" onClick={ResetMenu}>
              <img src="img/logo/cmy_logo.svg" className="logo" alt="exl" />
            </DelayLink>
            <div className="v">
              <img
                src="img/logo/logo-icon.png"
                className="logo-icon"
                alt="exl logo icon"
              />
            </div>
          </div>
          {/* <div className="rightmenu">
            {/* <div className="navbar-menu-container">
              <div className="menu-icon" onClick={handleClick}>
                <i className={click ? "fas fa-times" : "fas fa-bars"} />
              </div>
              <ul className={click ? "nav-menu active" : "nav-menu"}>
              </ul>
            </div> 
            <div className="navbar-profile-container">
              {sessionStorage.getItem("AuditFeed") === "1" && (
                <>
                  {/* {button && (
    <Link to="/ClinicalDashboard" buttonStyle="btn--noOutline" title="Dashboard">
      <DashboardIcon /> Dashboard
    </Link>
  )}
  {button && (
    <Link to="/AuditHome" buttonStyle="btn--noOutline" title="Home">
      <HomeOutlined /> Home
    </Link>
  )} 

                  {button && (
                    <Link
                      to="/TaskFeedAudit"
                      buttonStyle="btn--noOutline"
                      title="Audit Feed"
                    >
                      <TaskAltOutlined /> Audit Feed
                    </Link>
                  )}

                  {/* {button && (
    <Link to="/AuditHome" buttonStyle="btn--noOutline" title="Audit Home">
      <FactCheckOutlined /> Audit Home
    </Link>
  )} */}
          {/*{button && (
    <Link to="/ClinicalAudit" buttonStyle="btn--noOutline" title="Clinical Audit">
      <MonitorHeartOutlined /> Clinical Audit
    </Link>
  )}
                  {button && (
                    <Link
                      to="/Report"
                      buttonStyle="btn--noOutline"
                      title="Report"
                    >
                      <AssessmentOutlined /> Report
                    </Link>
                  )}
                </>
              )}

              {sessionStorage.getItem("ClinicalAudit") === "1" ? (
                <>
                  {button && (
                    <Link
                      to="/Report"
                      buttonStyle="btn--noOutline"
                      title="Dashboard"
                    >
                      <DashboardIcon /> Dashboard
                    </Link>
                  )}
                  {button && (
                    <Link
                      to="/AuditHome"
                      buttonStyle="btn--noOutline"
                      title="Home"
                    >
                      <HomeOutlined /> Home
                    </Link>
                  )}
                </>
              ) : sessionStorage.getItem("Clinical") === "1" ? (
                <>
                  {button && (
                    <Link
                      to="/Dashboard"
                      buttonStyle="btn--noOutline"
                      title="Dashboard"
                    >
                      <DashboardIcon /> Dashboard
                    </Link>
                  )}
                  {button && (
                    <Link
                      to="/ClinicalHome"
                      buttonStyle="btn--noOutline"
                      title="Home"
                    >
                      <HomeOutlined /> Home
                    </Link>
                  )}
                </>
              ) : sessionStorage.getItem("AuditFeed") === "1" ? (
                <>
                  {button && (
                    <Link
                      to="/OverallClinical"
                      buttonStyle="btn--noOutline"
                      title="Dashboard"
                    >
                      <DashboardIcon /> Dashboard
                    </Link>
                  )}
                  {button && (
                    <Link
                      to="/AuditHome"
                      buttonStyle="btn--noOutline"
                      title="Home"
                    >
                      <HomeOutlined /> Home
                    </Link>
                  )}
                </>
              ) : (
                <>
                  {button && (
                    <Link
                      to="/Dashboard"
                      buttonStyle="btn--noOutline"
                      title="Dashboard"
                    >
                      <DashboardIcon /> Dashboard
                    </Link>
                  )}
                  {button && (
                    <Link
                      to="/userHome"
                      buttonStyle="btn--noOutline"
                      title="Home"
                    >
                      <HomeOutlined /> Home
                    </Link>
                  )}
                </>
              )}

              {button && (
                <Link
                  to="/"
                  buttonStyle="btn--noOutline"
                  title={
                    sessionStorage.getItem("Fname") +
                    " " +
                    sessionStorage.getItem("Lname")
                  }
                >
                  <Person2OutlinedIcon /> Logout
                </Link>
              )}
            </div>
          </div> */}
        </nav>
      </>
    );
  } else {
    return (
      <>
        <nav className="navbar">
          <div className="navbar-container">
            <DelayLink delay="300" to="/" className="navbar-logo">
              <img src="exl_logo_rgb_orange_pos.png" className="logo" />
              <label className="navbar-title">vCare</label>{" "}
              <i className="fas fa-briefcase-medical"></i>
            </DelayLink>
            <div className="navbar-menu-container">
              <div className="menu-icon" onClick={handleClick}>
                <i className={click ? "fas fa-times" : "fas fa-bars"} />
              </div>
            </div>

            <div className="navbar-profile-container">
              {button && (
                <Button buttonStyle="btn--noOutline">
                  Welcome {sessionStorage.getItem("userName")}
                </Button>
              )}
            </div>
          </div>
        </nav>
      </>
    );
  }
}

export default Navbar;

// import React, { useState, useEffect } from "react";
// import { DelayLink } from "./DelayLink";
// import { Button } from "./Button";
// import "./../styles/Navbar.css";
// import { AccountCircleOutlined, HomeOutlined, TaskAltOutlined, FactCheckOutlined, MonitorHeartOutlined, AssessmentOutlined } from "@mui/icons-material";
// import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
// import DashboardIcon from "@mui/icons-material/DashboardTwoTone";
// import { Link } from "react-router-dom";

// function Navbar() {
//   const [click, setClick] = useState(false);
//   const [button, setButton] = useState(true);

//   const handleClick = () => setClick(!click);
//   const closeMobileMenu = () => {
//     setClick(false);
//   };

//   const showButton = () => {
//     if (window.innerWidth <= 1080) {
//       setButton(false);
//     } else {
//       setButton(true);
//     }
//   };

//   const ResetMenu = () => {
//     sessionStorage.clear();
//   };

//   useEffect(() => {
//     showButton();
//   }, []);

//   window.addEventListener("resize", showButton);

//   if (1 == 1) {
//     return (
//       <>
//         <nav className="topHeader-wrap">
//           <div className="logo-wrap">
//             <DelayLink to="/" className="exlLogo" onClick={ResetMenu}>
//               <img src="img/logo/cmy_logo.svg" className="logo" alt="Highmark" />
//             </DelayLink>
//           {/*  <div className="v">
//               <img
//                 src="img/logo/logo-icon.png"
//                 className="logo-icon"
//                 alt="exl logo icon"
//               />
//             </div>  */}
//           </div>
//           <div className="rightmenu">
//             {/* <div className="navbar-menu-container">
//               <div className="menu-icon" onClick={handleClick}>
//                 <i className={click ? "fas fa-times" : "fas fa-bars"} />
//               </div>
//               <ul className={click ? "nav-menu active" : "nav-menu"}>
//               </ul>
//             </div> */}
//             <div className="navbar-profile-container">
//             {sessionStorage.getItem("AuditFeed") === "1" &&

// <>
//   {button && (
//     <Link to="/ClinicalDashboard" buttonStyle="btn--noOutline" title="Dashboard">
//       <DashboardIcon /> Dashboard
//     </Link>
//   )}
//   {/*{button && (
//     <Link to="/AuditHome" buttonStyle="btn--noOutline" title="Home">
//       <HomeOutlined /> Home
//     </Link>
//   )}*/}

//   {button && (
//     <Link to="/TaskFeedAudit" buttonStyle="btn--noOutline" title="Audit Feed">
//       <TaskAltOutlined /> Audit Feed
//     </Link>
//   )}

//   {button && (
//     <Link to="/AuditHome" buttonStyle="btn--noOutline" title="Audit Home">
//       <FactCheckOutlined /> Audit Home
//     </Link>
//   )}
//  {/*{button && (
//     <Link to="/ClinicalAudit" buttonStyle="btn--noOutline" title="Clinical Audit">
//       <MonitorHeartOutlined /> Clinical Audit
//     </Link>
//   )}*/ }
//   {button && (
//     <Link to="/Report" buttonStyle="btn--noOutline" title="Report">
//       <AssessmentOutlined /> Report
//     </Link>
//   )}
// </>

// }
//               {sessionStorage.getItem("ClinicalAudit") === "1" ?

//                 <>
//                   {button && (
//                     <Link to="/ClinicalDashboard" buttonStyle="btn--noOutline" title="Dashboard">
//                       <DashboardIcon /> Dashboard
//                     </Link>
//                   )}
//                   {/*{button && (
//                     <Link to="/AuditHome" buttonStyle="btn--noOutline" title="Home">
//                       <HomeOutlined /> Home
//                     </Link>
//                   )}*/}

//                   {/* {button && (
//                     <Link to="/TaskFeedAudit" buttonStyle="btn--noOutline" title="Audit Feed">
//                       <TaskAltOutlined /> Audit Feed
//                     </Link>
//                   )} */}

//                   {/* {button && (
//                     <Link to="/AuditHome" buttonStyle="btn--noOutline" title="Audit Home">
//                       <FactCheckOutlined /> Audit Home
//                     </Link>
//                   )} */}
//                  {/*{button && (
//                     <Link to="/ClinicalAudit" buttonStyle="btn--noOutline" title="Clinical Audit">
//                       <MonitorHeartOutlined /> Clinical Audit
//                     </Link>
//                   )}*/ }
//                   {button && (
//                     <Link to="/Report" buttonStyle="btn--noOutline" title="Report">
//                       <AssessmentOutlined /> Report
//                     </Link>
//                   )}
//                 </>

//                 : sessionStorage.getItem("Clinical") === "1" ?
//                   <>
//                     {button && (
//                       <Link to="/Dashboard" buttonStyle="btn--noOutline" title="Dashboard">
//                         <DashboardIcon /> Dashboard
//                       </Link>
//                     )}
//                     {button && (
//                       <Link to="/ClinicalHome" buttonStyle="btn--noOutline" title="Home">
//                         <HomeOutlined /> Home
//                       </Link>
//                     )}
//                   </>
//                   : <>
//                     {button && (
//                       <Link to="/Dashboard" buttonStyle="btn--noOutline" title="Dashboard">
//                         <DashboardIcon /> Dashboard
//                       </Link>
//                     )}
//                     {button && (
//                       <Link to="/userHome" buttonStyle="btn--noOutline" title="Home">
//                         <HomeOutlined /> Home
//                       </Link>
//                     )}
//                   </>}

//               {button && (
//                 <Link
//                   to="/"
//                   buttonStyle="btn--noOutline"
//                   title={
//                     sessionStorage.getItem("Fname") +
//                     " " +
//                     sessionStorage.getItem("Lname")
//                   }
//                 >
//                   <Person2OutlinedIcon /> Logout
//                 </Link>
//               )}
//             </div>
//           </div>
//         </nav>
//       </>
//     );
//   } else {
//     return (
//       <>
//         <nav className="navbar">
//           <div className="navbar-container">
//             <DelayLink delay="300" to="/" className="navbar-logo">
//               <img src="exl_logo_rgb_orange_pos.png" className="logo" />
//               <label className="navbar-title">vCare</label>{" "}
//               <i className="fas fa-briefcase-medical"></i>
//             </DelayLink>
//             <div className="navbar-menu-container">
//               <div className="menu-icon" onClick={handleClick}>
//                 <i className={click ? "fas fa-times" : "fas fa-bars"} />
//               </div>
//             </div>

//             <div className="navbar-profile-container">
//               {button && (
//                 <Button buttonStyle="btn--noOutline">
//                   Welcome {sessionStorage.getItem("userName")}
//                 </Button>
//               )}
//             </div>
//           </div>
//         </nav>
//       </>
//     );
//   }
// }

// export default Navbar;
